import api from '../../config/AxiosService';
import { Flow, FlowStatistic } from '../../types/flow';
import { Pagination } from '../../types';

export const getFlowsForAlgorithm = async (algorithmId: number, { page, pageSize }: Pagination) => {
  const { data } = await api.get(`/flows/list/${algorithmId}?page=${page}&size=${pageSize}`);
  return { items: data.items, totalItems: data.meta.totalItems };
};

export const createFlow = async (
  name: string,
  modelId: number,
  rules: { fields: { fieldName: string; rules: string[] }[] },
  batchReports: {}
) => {
  const body = { name, rules, batchReports };
  const { data } = await api.post(`/flows/create/${modelId}`, body);
  return data;
};

export const renameFlow = async (name: string, id: string) => {
  const body = { name };
  const { data } = await api.put(`/flows/${id}/`, body);
  return data;
};

export const createMulti = async (
  name: string,
  flowName: string,
  customer: string,
  rules: { fields: { fieldName: string; rules: string[] }[] },
  batchReports: {}
) => {
  const modelId = '10000000'; //unique id for multiflow
  const body = { name, rules, batchReports, multiflowName: flowName, multiflowCustomer: customer };
  const { data } = await api.post(`/flows/create-multi/${modelId}`, body);
  return data;
};

export const getMultiflowStatus = async (runId: string) => {
  const { data } = await api.get(`/api/${runId}/status`);
  return data.info;
};

export const addInvoicesToFlow = async (flowId: string, batchReports: {}) => {
  const body = { batchReports };
  const { data } = await api.post(`/flows/add-files/${flowId}`, body);
  return data;
};

export const deleteFlow = async (flowId: string) => {
  await api.delete(`/flows/${flowId}`);
};

export const getFlow = async (flowId: string): Promise<Flow> => {
  const response = await api.get(`/flows/${flowId}`);
  return response.data;
};

export const getFlowInferenceList = async (flowId: string, params: Pagination, filter?: string): Promise<any> => {
  const response = await api.get(
    `/flows/inference-list/${flowId}?page=${params.page}&size=${params.pageSize}` + (filter ? `&status=${filter}` : '')
  );
  return { items: response.data.items, totalItems: response.data.meta.totalItems };
};

export const getFlowStats = async (monthstring: string) => {
  const response = await api.get(`api/monthly-summary?mmyyyy=${monthstring}`);
  return response.data;
};

export const getFlowListStatus = async (flowId: string): Promise<{ [id: string]: any }> => {
  const response = await api.get(`flows/inference-list/${flowId}/status`);
  return response.data;
};

export const getFlowStatistics = async (flowId: string): Promise<FlowStatistic> => {
  const response = await api.get(`flows/${flowId}/statistics`);
  return response.data;
};

export const compare = async (inferenceId: string, modelId: number, modelVersionId: string) => {
  const response = await api.post(`/inference/start-comparison/${inferenceId}`, { modelId, modelVersionId });
  return response.data;
};
